/**
 * Remove legacy Drop Fee / convenience-fee lines from carts.
 * Fee is no longer used.
 */
(function () {
  const FEE_HANDLE = 'convenience-fee';
  const FEE_SKU = 'CONV-FEE-5';
  let running = false;

  function isFeeItem(item) {
    if (!item) return false;
    const handle = (item.handle || item.product_handle || '').toLowerCase();
    if (handle === FEE_HANDLE) return true;
    if ((item.sku || '') === FEE_SKU) return true;
    if (item.properties && item.properties._minnies_fee === 'convenience') return true;
    return false;
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    if (!res.ok) throw new Error('change failed');
    return res.json();
  }

  async function removeLegacyFees() {
    if (running) return;
    running = true;
    try {
      const cart = await getCart();
      const fees = (cart.items || []).filter(isFeeItem);
      for (const fee of fees) {
        await changeLine(fee.key, 0);
      }
      if (fees.length) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'minnies-order-fees-cleanup' });
          } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.warn('[minnies-order-fees]', err);
    } finally {
      running = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLegacyFees);
  } else {
    removeLegacyFees();
  }
})();
